const Sentry = require('@sentry/browser');

const gtxConstants = require('@getrix/common/js/gtx-constants');
const isInternalPath = require('../../../commons/lib/is-internal-path');
const mixpanel = require('lib/mixpanel');
class MixpanelManager {
    constructor() {
        this.localStorageKey = 'webPushEventSent';
    }

    initialize() {
        /**
         * If it's initialized immediately via app-shell, the mixpanel init within useMixpanel becomes meaningless.
         * We must always use mixpanel via hook; there's a check in the fn track that ensures init is always called the first time.
         * Additionally, mixpanelProvider also contains an init with custom configurations.
         * If we initialize it here, the next init won't be executed, so the custom configurations needed to start the session in sampling mode won't be executed.
         */
        // mixpanel.init();

        /**
         * Stops recording the Mixpanel session when the user leaves the page.
         * This is necessary to avoid recording unwanted pages.
         * If the user leaves the page via gx-navigation, it's not possible to detect the page unmounting.
         * So we need to do it here, which is the only page that is always called on all pages.
         */
        // TODO remove comment if you want to have session replay only on some pages
        //  window.addEventListener('beforeunload', function () {
        //      if (window.mixpanel && typeof window.mixpanel.stop_session_recording === 'function') {
        //            window.mixpanel.stop_session_recording();
        //      }
        // });
        // TODO remove row if you want to have session replay only on some pages
        mixpanel.init();
    }

    track() {
        if (Boolean(gtxConstants('MIXPANEL_IDENTIFY_TRACKING')) && isInternalPath()) {
            const webPushEventSent = window.localStorage.getItem(this.localStorageKey);

            if (!webPushEventSent) {
                let permissionMapped = 'unsupported';

                if ('Notification' in window) {
                    switch (Notification.permission) {
                        case 'granted':
                            permissionMapped = 'active';
                            break;
                        case 'denied':
                            permissionMapped = 'consent denied';
                            break;
                        case 'default':
                            permissionMapped = 'waiting for consent';
                    }
                }

                const url = `/api/tracking/identify`;
                const data = {
                    webPushState: permissionMapped,
                };

                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                    .then((response) => {
                        if (!response.ok) {
                            // eslint-disable-next-line no-undef
                            if (globalVars.SENTRY_ENABLED) {
                                Sentry.captureException(new Error(`HTTP error! status: ${response.status}`));
                            }
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        window.localStorage.setItem(this.localStorageKey, 'true');
                    })
                    .catch((error) => {
                        // eslint-disable-next-line no-undef
                        if (globalVars.SENTRY_ENABLED) {
                            Sentry.captureException(error);
                        }
                        console.error('Request failed:', error);
                    });
            }
        }
    }
}

module.exports = MixpanelManager;
